<template>
  <div id="pulseConfirmation">
    <el-card
      :style="{width: dialogWidth}"
      shadow="hover"
      :body-style="{padding: dialogPadding}"
    >
      <el-row
        type="flex"
        :gutter="30"
      >
        <el-col
          :span="responsiveCol.one"
          class="colLogo"
        >
          <i class="title el-icon-circle-check"></i>
        </el-col>
        <el-col
          :span="responsiveCol.two"
          class="colContent"
        >
          <div class="content">
            <i18n path="pulse.survey.submitted.thankYouFor">
              <template #textByRole>
                <span v-if="role === 'leader'">
                  {{ $t('pulse.survey.submitted.byLeader') }}
                </span>
                <span v-else>
                  <i18n path="pulse.survey.submitted.byCoworker">
                    <template #leader>
                      {{ pulseData.leader_first_name }}
                    </template>
                  </i18n>
                </span>
              </template>
            </i18n>
            <br />
            <br />
            <i18n path="pulse.survey.submitted.pleaseContact">
              <template #coach>
                {{ confirmedData.coach.first_name }} {{ confirmedData.coach.last_name }}
              </template>
              <template #coachEmail>
                {{ confirmedData.coach.email }}
              </template>
            </i18n>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
export default {
  props: {
    role: {
      type: String,
      default: 'stakeholder',
    },
    dialogWidth: {
      type: String,
      default: '50%',
    },
    dialogPadding: {
      type: String,
      default: '20px',
    },
    pulseData: {
      type: Object,
      default: null,
    },
    confirmedData: {
      type: Object,
      default: () => ({
        coach: {
          first_name: '',
          last_name: '',
          email: '',
        },
      }),
    },
  },
  computed: {
    responsiveCol() {
      const col = {};
      if (['mobile', 'tablet'].includes(this.$mq)) {
        col.one = 24;
        col.two = 24;
      } else {
        col.one = 4;
        col.two = 20;
      }
      return col;
    },
  },
};
</script>

<style lang="scss" scoped>
#pulseConfirmation {
  height: 100%;
  min-height: calc(100vh - 40px);
  display: flex;
  flex-direction: column;
  justify-content: center;

  .el-row {
    flex-wrap: wrap;

    .el-col {
      justify-content: center;
      align-self: center;

      &.colLogo {
        text-align: center;
        padding: 20px 0;
      }

      &.colContent {
        padding: 15px;
      }
    }
  }

  .el-card {
    width: 35%;
    margin: 0 auto;
    text-align: left;
    background-color: rgba(255, 255, 255, 0.9);

    .title {
      font-size: 70px;
      color: #00ace2;
    }
  }
}
</style>
